import styles from '../assets/scss/globals/_variable.scss';

export default {
    contentStyle: {
        width: "auto",
        fontSize: "14px",
        lineHeight: "1em",
        background: styles.darkColor,
        color: styles.greenColor,
        padding: "10px",
        border: "none",
        borderRadius: "8px",
        boxShadow: "none"
    },
    arrowStyle: {
        width: "auto",
        height: "auto",
        position: "absolute",
        background: styles.darkColor,
        boxShadow: "none",
        borderWidth: "5px",
        borderStyle: "solid",
        borderColor: "transparent transparent " + styles.darkColor + " transparent"
    }
}